export default [
  {
    path: '/privacy',
    component: () => import('@/views/privacy/MsPrivacy.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/thirdparty',
    component: () => import('@/views/privacy/ThirdParty.vue'),
    meta: {
      anonymous: true,
    },
  },
]